module.exports = __webpack_public_path__ + "img/ao.462d227e.svg";